import InviteBody from "pages/PanelPage/components/selectedAssessment/assessmentInvite/InviteBody/InviteBody";

export default InviteBody;
